import React from "react";
import { ReviewsList } from "components/review/ReviewsList";
import { FacilityPageSection } from "components/facility/FacilityPageSection";

const ReviewsSection = ({ ...rest }) => (
	<FacilityPageSection
		className="reviews-section"
		title="Reviews"
		isCollapsable
		autoHeight
		id="reviews"
	>
		<ReviewsList {...rest} />
	</FacilityPageSection>
);

export default ReviewsSection;
